/** Kurulum / Arıza / Bakım — checklist bu işlem tiplerinde (MA ile uyumlu) */
export function isChecklistIslemTipi(islemTipi) {
  const t = String(islemTipi ?? '').trim().toLowerCase();
  return (
    t.includes('kurulum') ||
    t.includes('arıza') ||
    t.includes('ariza') ||
    t.includes('bakım') ||
    t.includes('bakim')
  );
}

export function hasChecklistSablon(sablon) {
  if (!sablon || typeof sablon !== 'object') return false;
  if (Array.isArray(sablon.sorular) && sablon.sorular.length > 0) return true;
  return Boolean(sablon._id || sablon.id);
}

/** Tamamlama veya şablon verisi anlamlı mı? */
export function hasMeaningfulChecklistTamamlama(ct) {
  if (ct == null || typeof ct !== 'object') return false;
  if (ct.tamamlanmaTarihi) return true;
  if (Array.isArray(ct.cevaplar) && ct.cevaplar.length > 0) return true;
  if (Array.isArray(ct.sorularSnapshot) && ct.sorularSnapshot.length > 0) return true;
  return false;
}

export function shouldShowChecklistTab(appointment, serviceRecord) {
  if (!appointment) return false;
  const hasSablon = hasChecklistSablon(appointment.checklistSablon);
  const hasTamamlama = hasMeaningfulChecklistTamamlama(appointment.checklistTamamlama);
  if (!hasSablon && !hasTamamlama) return false;

  const islemTipi =
    serviceRecord?.islemTipi ??
    appointment.servisKaydi?.islemTipi ??
    appointment.serviceRecord?.islemTipi;

  return isChecklistIslemTipi(islemTipi) || hasTamamlama;
}
